import { CustomIconProps } from 'assets/Icons/LibraryIcon';
import React from 'react';

const PauseIcon: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ?? '11'}
      height={height ?? '10'}
      viewBox='0 0 11 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M7.14463 0.390625V9.99063H10.3446V0.390625H7.14463Z'
        fill={fill ?? 'black'}
      />
      <path
        d='M0.744629 0.390625V9.99063H3.94463V0.390625H0.744629Z'
        fill={fill ?? 'black'}
      />
    </svg>
  );
};

export default PauseIcon;
